import React from "react"
import Badge from "@react/shared/ui/Badge"
import { CATEGORY_COLORS } from "../../form/qlines/shared/category_styles"

const TONES = {
  labor:          "blue",
  equipment:      "violet",
  materials:      "emerald",
  subcontracting: "amber",
  other:          "slate",
}

const CategoryPill = ({ category, size = "sm" }) => {
  if (!category) return null
  const tone  = TONES[category] || "slate"
  const color = CATEGORY_COLORS[category] || "#6b7280"
  const label = I18n.t(`quotes.new.cost_category.${category}`)

  return (
    <Badge tone={tone} variant="soft" size={size === "xs" ? "xs" : "sm"} className="gap-1.5">
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      {label}
    </Badge>
  )
}

export default CategoryPill
